export const EXPIRE_TIME = 'expire_time'; // expire key for local storage.
export const LOGGED_IN_USER_EMAIL = 'logged_user'; // expire key for local storage.

import {
  AUTH_LOG_IN,
  AUTH_RESET_PASSWORD,
  AUTH_REGISTER,
  AUTH_CHECK_YOUR_EMAIL,
  AUTH_TROUBLE_LOGGING_IN,
  AUTH_REGISTRATION_SUCCESS,
  AUTH_TERMS_AND_CONDITIONS,
  PLAN_YOUR_BENEFITS_AT_A_GLANCE,
  PLAN_YOUR_BENEFITS_ARE_ON_THE_WAY,
  PLAN_NEXT_YOULL_ENTER_AND_STORE,
  PLAN_YOUR_BENEFITS_TEAM_IS_WORKING,
  PLAN_WHICH_MEDICAL_PLAN_DO_YOU_HAVE,
  PLAN_MEDICAL,
  PLAN_YOUR_MEDICAL_ID_CARD,
  PLAN_WHICH_DENTAL_PLAN_DO_YOU_HAVE,
  PLAN_DENTAL,
  PLAN_YOUR_DENTAL_ID_CARD,
  PLAN_WHICH_VISION_PLAN_DO_YOU_HAVE,
  PLAN_VISION,
  PLAN_YOUR_VISION_ID_CARD,
  PLAN_ID_CARD,
} from 'constants/languageConstants';

export const AUTH_VIEW = {
  LOGIN: { type: 'LOGIN', value: AUTH_LOG_IN },
  REQUEST_RESET: { type: 'REQUEST_RESET', value: AUTH_RESET_PASSWORD },
  PWD_RESET: { type: 'PWD_RESET', value: AUTH_RESET_PASSWORD },
  REGISTER: { type: 'REGISTER', value: AUTH_REGISTER },
  EMAIL: { type: 'EMAIL', value: AUTH_REGISTER },
  CODE: { type: 'CODE', value: AUTH_REGISTER },
  ROSTER: { type: 'ROSTER', value: AUTH_REGISTER },
  PERSONAL: { type: 'PERSONAL', value: AUTH_REGISTER },
  VERIFY: { type: 'VERIFY', value: AUTH_CHECK_YOUR_EMAIL },
  FALL_BACK: { type: 'FALL_BACK', value: AUTH_TROUBLE_LOGGING_IN },
  SSO_REGISTER: { type: 'SSO_REGISTER' },
  ER_ADMIN: { type: 'ER_ADMIN', value: AUTH_REGISTRATION_SUCCESS },
  TERMS: { type: 'TERMS', value: AUTH_TERMS_AND_CONDITIONS },
};

export const PLAN_VIEW: Record<string, any> = {
  ON_BOARDING: {
    type: 'ON_BOARDING',
    title: PLAN_YOUR_BENEFITS_AT_A_GLANCE,
    fallBackTitle: PLAN_YOUR_BENEFITS_ARE_ON_THE_WAY,
    descripion: PLAN_NEXT_YOULL_ENTER_AND_STORE,
    fallBackDescription: PLAN_YOUR_BENEFITS_TEAM_IS_WORKING,
  },
  MEDICAL: {
    type: 'MEDICAL',
    title: PLAN_WHICH_MEDICAL_PLAN_DO_YOU_HAVE,
    value: PLAN_MEDICAL,
    viewTitle: PLAN_YOUR_MEDICAL_ID_CARD,
  },
  DENTAL: {
    type: 'DENTAL',
    title: PLAN_WHICH_DENTAL_PLAN_DO_YOU_HAVE,
    value: PLAN_DENTAL,
    viewTitle: PLAN_YOUR_DENTAL_ID_CARD,
  },
  VISION: {
    type: 'VISION',
    title: PLAN_WHICH_VISION_PLAN_DO_YOU_HAVE,
    value: PLAN_VISION,
    viewTitle: PLAN_YOUR_VISION_ID_CARD,
  },
  CARD: {
    type: 'CARD',
    value: PLAN_ID_CARD,
  },
  TERMS: {
    type: 'TERMS',
    value: AUTH_TERMS_AND_CONDITIONS,
  },
};

export const LoginType = {
  PWD: 'PWD',
  SSO: 'SSO',
};

export const URIAuthTypes = {
  DBG_RESET_PWS: 'DBG_RESET_PWS',
  DBG_SIGNUP: 'DBG_SIGNUP',
  ID_CARD: 'ID_CARD',
};
